export default function PhotoDropzone({
  inputRef,
  onInputChange,
  onDrop,
}) {
  return (
    <>
      <div
        className="photo-dropzone"
        onClick={() => inputRef.current?.click()}
        onDragOver={(e) => e.preventDefault()}
        onDrop={onDrop}
        role="button"
        tabIndex={0}
      >
        <strong>Arrastra y suelta aquí tus fotos</strong>
        <span>o haz clic para seleccionarlas</span>
      </div>

      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        multiple
        hidden
        onChange={onInputChange}
      />
    </>
  );
}